import React from "react";
import glyphMark from "../assets/glyph-logo.svg";
import anzegWordmark from "../assets/anzeg-wordmark.png";
import "./Footer.scss";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="siteFooter">
      <div className="container siteFooter__grid">
        <div className="siteFooter__col">
          <p className="siteFooter__brand">
            <img src={anzegWordmark} alt="ANZEG" />
            <strong>institute</strong>
          </p>
          <p className="lede">
            Chamber of Commerce &amp; Cultural Exchange connecting Australia,
            New Zealand and Egypt.
          </p>
          <a href="mailto:info@anzeginstitute.org">info@anzeginstitute.org</a>
        </div>

        <div className="siteFooter__col">
          <p className="siteFooter__heading">Contact</p>
          <p>Sydney, NSW, Australia</p>
          <p>Auckland, New Zealand</p>
          <p>Cairo, Egypt</p>
          <a href="tel:+0226772013">+022 677 2013</a>
        </div>

        <div className="siteFooter__col">
          <p className="siteFooter__heading">Explore</p>
          <a href="/membership">Membership</a>
          <a href="/events">Future Events</a>
          <a href="/past-events">Past Events</a>
          <a href="/cultural-exchange">Cultural Exchange</a>
        </div>

        <div className="siteFooter__col">
          <p className="siteFooter__heading">Follow Us</p>
          <div className="siteFooter__social">
            <a
              href="https://www.facebook.com/share/19PzDk2nEE/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="ANZEG on Facebook"
            >
              <i className="fa-brands fa-facebook-f"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="container siteFooter__bottom">
        <p>&copy; {year > 2024 ? `2024–${year}` : "2024"} ANZEG Institute. All rights reserved.</p>
        <a
          href="https://glyphtechnology.net/"
          className="siteFooter__credit"
          target="_blank"
          rel="noopener noreferrer"
        >
          Powered by
          <span
            className="siteFooter__creditLogo"
            aria-hidden="true"
            style={{ "--glyph-mark": `url(${glyphMark})` }}
          />
          Glyph
        </a>
      </div>
    </footer>
  );
};

export default Footer;
